import {CategoryFilter, Filter, MaxPriceFilter, MinPriceFilter, ProductFilter} from './IO/Input/Filters'
import {RecommendationError} from './IO/Output/Error'

/**
 * Api helps create specific Filter
 */
export class FilterApi {
    static category(category: string): CategoryFilter {
        return new CategoryFilter(category)
    }

    static product(productId: string): ProductFilter {
        return new ProductFilter(productId)
    }

    static minPrice(minPrice: string): MinPriceFilter {
        return new MinPriceFilter(minPrice)
    }

    static maxPrice(maxPrice: string): MaxPriceFilter {
        return new MaxPriceFilter(maxPrice)
    }

    static getFilterParams(filters: Filter[]): Record<string,string> {
        if (!filters) {
            return {}
        }
        const filterParams: Record<string,string> = {}
        filters.forEach(filter => {
            if (!filter.enableMultiple && typeof filterParams[filter.urlParam] !== 'undefined') {
                throw new RecommendationError('Filter used multiple times')
            }
            filterParams[filter.urlParam] = FilterApi.appendFilterParams(filter.value, filterParams[filter.urlParam])
        })
        return filterParams
    }

    private static appendFilterParams(filterValue: string|number, urlParam: string): string {
        if (typeof urlParam === 'undefined') {
            return filterValue.toString().trim()
        }
        return urlParam + ',' + filterValue.toString().trim()
    }
}